
riot.tag2('modification-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">{title}</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.name}">\n              <label class="control-label">Наименование</label>\n              <input class="form-control" name="name" value="{item.name}">\n              <div class="help-block">{error.name}</div>\n            </div>\n          </div>\n        </div>\n        <div class="row">\n          <div class="col-md-12">\n            <div class="form-group {has-error: error.type}">\n              <label class="control-label">Тип цены</label>\n              <select class="form-control" name="vtype" value="{item.vtype}">\n                <option value="0">Добавляет к цене</option>\n                <option value="1">Умножает на цену</option>\n                <option value="2">Замещает цену</option>\n              </select>\n              <div class="help-block">{error.vtype}</div>\n            </div>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.item = opts.item || {};
    modal.mixin('validation');
    modal.mixin('change');
    modal.title = opts.title;

    modal.rules = {
        name: 'empty',
        values: {
            required: true,
            rules: [{
                vtype: 'minLength[1]',
                prompt: 'В списке должно быть не менее одного элемента'
            }]
        }
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };
});
});


// WEBPACK FOOTER //
// ./pages/products/modifications/modification-edit-modal.tag